import {
	SET_BROWSER_DATA,
	CHANGE_BROWSER_DATA_WHEN_DELETE,
	CHANGE_BROWSER_DATA_WHEN_ADD,
	CHANFE_BROWSER_DATA_WHEN_RENAME
} from '../../constants';

const initialState = {
	browserData: []
};

const filesReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_BROWSER_DATA:
			return {
				browserData: action.payload
			};
		case CHANGE_BROWSER_DATA_WHEN_DELETE:
			return {
				browserData: state.browserData.filter((elem) => ~action.payload.indexOf(elem.label) >= 0)
			};
		case CHANGE_BROWSER_DATA_WHEN_ADD:
			return {
				browserData: JSON.parse(action.payload.value).isFolder
					? [ action.payload, ...state.browserData ]
					: [ ...state.browserData, action.payload ]
			};
		case CHANFE_BROWSER_DATA_WHEN_RENAME:
			return {
				browserData: action.payload
			};
		default:
			return state;
	}
};

export default filesReducer;
